import React, { useState } from 'react'
import { useAppSelector } from '../../_App/Redux/hooks'
import { ListOrganisations } from '../../_App/Redux/Slices/organisations/organisationSlice'
import Select from "react-select";
import { ListFournisseurs } from '../../_App/Redux/Slices/fournisseur/fournisseurSlice';

export default function FiltreReception({ t, setFiltre, Filtre, listDepots, searchfiltre }: any) {
    const listOrganisation = useAppSelector(ListOrganisations)
    const listfournisseur = useAppSelector(ListFournisseurs)


    return (
        <div>
            <div className="  bg-white" style={{ padding: "10px" }}>
                <div className="row">
                    <div className="col-1">
                        <div className="form-group">
                            <label htmlFor="carte">
                                {" "}
                                <span style={{ color: "red" }}></span>
                                {t("Etat")}
                            </label>
                            <select
                                className=" form-control "
                                value={Filtre.etat}
                                onChange={(e) => setFiltre((prev: any) => ({
                                    ...prev,
                                    etat: e.target.value,
                                }))}
                            >
                                <option key={'tout'}>{t('tout')}</option>
                                <option key={'en cours'}>{t('en cours')}</option>
                                <option key={'confirmé'}>{t('confirmé')}</option>
                                <option key={'cloturé'}>{t('cloturé')}</option>
                            </select>

                        </div>
                    </div>
                    <div className='col-2'>
                        <div className="form-group">
                            <label htmlFor="carte">
                                {" "}
                                <span style={{ color: "red" }}></span>
                                {t("Organisation")}
                            </label>

                            <select
                                className=" form-control "
                                value={Filtre.organisation}
                                onChange={(e) => setFiltre((prev: any) => ({
                                    ...prev,
                                    organisation: e.target.value,
                                }))}
                            >
                                {listOrganisation.map(org =>
                                    <option key={org._id} value={org._id}>
                                        {org.nom}
                                    </option>
                                )}
                                <option key="null" value={'null'}>{t('Societe')}</option>

                            </select>
                        </div>
                    </div>
                    <div className='col-2'>
                        <div className="form-group">
                            <label htmlFor="carte">
                                {" "}
                                <span style={{ color: "red" }}></span>
                                {t("Depots")}
                            </label>

                            {<select
                                className=" form-control "
                                value={Filtre.depots}
                                onChange={(e) => setFiltre((prev: any) => ({
                                    ...prev,
                                    depots: e.target.value,
                                }))}
                            >
                                {listDepots[Filtre.organisation] && listDepots[Filtre.organisation].map(org =>
                                    <option key={org._id}>
                                        {org.libelle}
                                    </option>
                                )}

                            </select>}
                        </div>
                    </div>

                    <div className="col-2">
                        <div className="form-group">
                            <label htmlFor="carte">
                                {" "}
                                <span style={{ color: "red" }}></span>
                                {t("Date debut")}
                            </label>
                            <input
                                type="date"
                                className="form-control "
                                value={Filtre.date_debut}
                                onChange={(e) => setFiltre((prev: any) => ({
                                    ...prev,
                                    date_debut: e.target.value,
                                }))}
                            />
                        </div>
                    </div>
                    <div className="col-2">
                        <div className="form-group">
                            <label htmlFor="carte">
                                <label>{t("Date fin")}</label>

                            </label>
                            <input
                                type="date"
                                className="form-control "
                                value={Filtre.date_fin}
                                onChange={(e) => setFiltre((prev: any) => ({
                                    ...prev,
                                    date_fin: e.target.value,
                                }))}
                            />
                        </div>
                    </div>
                    <div className="col-2">
                        <div className="form-group">
                            <label htmlFor="carte">
                                <label>{t("Fournisseur")}</label>

                            </label>
                            <select
                                className=" form-control "
                                value={Filtre.fournisseur}
                                onChange={(e) => setFiltre((prev: any) => ({
                                    ...prev,
                                    organisation: e.target.value,
                                }))}
                            >
                                <option key="" value={''}>{t('tout')}</option>

                                {listfournisseur.map(org =>
                                    <option key={org._id} value={org._id}>
                                        {org.libelle}
                                    </option>
                                )}

                            </select>
                        </div>
                    </div>
                    <div
                        className="col-1 mt-4"
                        style={{ fontSize: "30px" }}
                        onClick={searchfiltre}
                    >
                        {" "}
                        <i className="fas fa-search"></i>
                    </div>
                </div>
            </div>




        </div >
    )
}
